import { render, staticRenderFns } from "./DonationPayments.vue?vue&type=template&id=79b7b057&"
import script from "./DonationPayments.vue?vue&type=script&lang=js&"
export * from "./DonationPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports